import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type IndexList = paths['/v4/index/'];

const getIndexList = createRequest<IndexList>('/pc/v4/index/');

export default getIndexList;
